import React, { FC } from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import Button from "@components/Button/Button"

import { getImgixImageData } from "@utils"

import { InterviewBuilderStartPanelsDIV } from "./InterviewBuilderStartPanels.styles"
import { GA_CUSTOM_EVENTS, STATE_PRESETS_TITLES, STATE_PRESETS } from "../../_store/constants"
import { logCustomGAEvent } from "../../_utils"

type InterviewBuilderStartPanelsProps = {
  hasStartedInterview: boolean
  onSelectStatePreset: (presetName: STATE_PRESETS) => void
}

const InterviewBuilderStartPanels: FC<InterviewBuilderStartPanelsProps> = ({
  hasStartedInterview,
  onSelectStatePreset,
}) => {
  return (
    <InterviewBuilderStartPanelsDIV>
      <div>
        <GatsbyImage
          alt={"Custom interview"}
          image={getImgixImageData(
            "/images/pages/interview-builder/InterviewBuilder--AppStartPagePanels--icon-custom-interview.png",
            120,
            280 / 190
          )}
        />
        {!hasStartedInterview ? (
          <>
            <h3>
              Craft a custom
              <br />
              interview from scratch
            </h3>
            <p>
              A blank interview that you can fill with questions that suit your
              specific role.
            </p>
            <Button onClick={() => {
              onSelectStatePreset(STATE_PRESETS.DEFAULT)
              logCustomGAEvent(GA_CUSTOM_EVENTS.SELECT_CUSTOM_INTERVIEW, null)
            }}>
              Create a new interview
            </Button>
          </>
        ) : (
          <>
            <h3>
              Continue building<br />
              your interview
            </h3>
            <p>
              Pick up where you left off with your interview–add and sort questions, or export it to a PDF.
            </p>
            <Button onClick={() => onSelectStatePreset(STATE_PRESETS.DEFAULT)}>
              Continue building
            </Button>
          </>
        )}

      </div>

      <div>
        <GatsbyImage
          alt={"Sample interview"}
          image={getImgixImageData(
            "/images/pages/interview-builder/InterviewBuilder--AppStartPagePanels--icon-sample-interview.png",
            120,
            280 / 190
          )}
        />
        <h3>
          Get started with a<br />
          sample interview
        </h3>
        <p>
          Pick a common role, start with our pre-selected questions, and edit
          from there.
        </p>
        <select
          className="size--M"
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onSelectStatePreset(e.target.value as STATE_PRESETS)}
          value={"placeholder"}
        >
          <option value="placeholder" disabled>
            Choose a sample interview
          </option>
          {Object.keys(STATE_PRESETS)
            .filter((preset) => preset !== STATE_PRESETS.DEFAULT)
            .map((preset) => (
              <option
                key={`start-panel-dropdown-question-${preset}`}
                value={preset}
              >
                {STATE_PRESETS_TITLES[preset]}
              </option>
            ))}
        </select>
      </div>
    </InterviewBuilderStartPanelsDIV>
  )
}

export default InterviewBuilderStartPanels
